var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPractice013X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "75px",
    viewBox: "0 0 104 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Practice-01@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.0182325%",
    y1: "100%",
    x2: "68.1749222%",
    y2: "37.9764392%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F8FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CREATE-ACCOUNT-NO-EMAIL-MATCH---NO-AETNA",
    transform: "translate(-937.000000, -135.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Practice-01",
    transform: "translate(937.000000, 135.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-2",
    transform: "translate(26.000000, 9.000000)",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0377412,64.6509931 L35.5122706,64.6509931 L35.5122706,47.5195947 L25.0107412,47.5195947 C25.0107412,47.5195947 25.0107412,64.6509931 25.0107412,64.6509931 L4.48527059,64.6509931 C2.28809412,64.6509931 0.507623529,62.8520066 0.507623529,60.6334829 L0.507623529,19.0639914 C0.507623529,16.8454677 29.3316488,1.42108547e-14 30.2615059,1.42108547e-14 C31.0487729,1.42108547e-14 60.0153882,16.8454677 60.0153882,19.0639914 L60.0153882,60.6334829 C60.0153882,62.8520066 58.2335647,64.6509931 56.0377412,64.6509931 Z",
    id: "Stroke-1",
    stroke: "#23356C",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.549835294,
    y1: 22.217043,
    x2: 60.0576,
    y2: 22.217043,
    id: "Stroke-3",
    stroke: "#23356C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0156706,39.8977537 L8.50161176,39.8977537 C7.95367059,39.8977537 7.50855294,39.4483465 7.50855294,38.8930367 L7.50855294,30.2932024 C7.50855294,29.7378927 7.95367059,29.2884855 8.50161176,29.2884855 L17.0156706,29.2884855 C17.5649647,29.2884855 18.0100824,29.7378927 18.0100824,30.2932024 L18.0100824,38.8930367 C18.0100824,39.4483465 17.5649647,39.8977537 17.0156706,39.8977537 Z",
    id: "Stroke-9",
    stroke: "#158CCC",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5178588,39.8977537 L26.0038,39.8977537 C25.4558588,39.8977537 25.0107412,39.4483465 25.0107412,38.8930367 L25.0107412,30.2932024 C25.0107412,29.7378927 25.4558588,29.2884855 26.0038,29.2884855 L34.5178588,29.2884855 C35.0671529,29.2884855 35.5122706,29.7378927 35.5122706,30.2932024 L35.5122706,38.8930367 C35.5122706,39.4483465 35.0671529,39.8977537 34.5178588,39.8977537 Z",
    id: "Stroke-11",
    stroke: "#158CCC",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0196412,39.8977537 L43.5069353,39.8977537 C42.9576412,39.8977537 42.5125235,39.4483465 42.5125235,38.8930367 L42.5125235,30.2932024 C42.5125235,29.7378927 42.9576412,29.2884855 43.5069353,29.2884855 L52.0196412,29.2884855 C52.5689353,29.2884855 53.0140529,29.7378927 53.0140529,30.2932024 L53.0140529,38.8930367 C53.0140529,39.4483465 52.5689353,39.8977537 52.0196412,39.8977537 Z",
    id: "Stroke-13",
    stroke: "#158CCC",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0156706,57.5786002 L8.50161176,57.5786002 C7.95367059,57.5786002 7.50855294,57.129193 7.50855294,56.5738832 L7.50855294,47.974049 C7.50855294,47.4200969 7.95367059,46.969332 8.50161176,46.969332 L17.0156706,46.969332 C17.5649647,46.969332 18.0100824,47.4200969 18.0100824,47.974049 L18.0100824,56.5738832 C18.0100824,57.129193 17.5649647,57.5786002 17.0156706,57.5786002 Z",
    id: "Stroke-15",
    stroke: "#158CCC",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0196412,57.5786002 L43.5069353,57.5786002 C42.9576412,57.5786002 42.5125235,57.129193 42.5125235,56.5738832 L42.5125235,47.974049 C42.5125235,47.4200969 42.9576412,46.969332 43.5069353,46.969332 L52.0196412,46.969332 C52.5689353,46.969332 53.0140529,47.4200969 53.0140529,47.974049 L53.0140529,56.5738832 C53.0140529,57.129193 52.5689353,57.5786002 52.0196412,57.5786002 Z",
    id: "Stroke-19",
    stroke: "#158CCC",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#158CCC",
    cx: 9.5,
    cy: 13.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#ABCFE3",
    cx: 92,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.5,
    y1: 32.5,
    x2: 100.5,
    y2: 41.5,
    id: "Line-4",
    stroke: "#158CCC",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.5,
    y1: 35.9017543,
    x2: 97.5,
    y2: 35.9017543,
    id: "Line-4",
    stroke: "#158CCC",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 52.5,
    x2: 3.5,
    y2: 61.5,
    id: "Line-4",
    stroke: "#B5D4E5",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 55.9017543,
    x2: 0.5,
    y2: 55.9017543,
    id: "Line-4",
    stroke: "#B5D4E5",
    strokeLinecap: "square"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractice013X);
export default __webpack_public_path__ + "static/media/Practice-01@3x.55eaabb81e3d745e7e9a38243fdbbe2b.svg";
export { ForwardRef as ReactComponent };